<div class="max-w-md w-full space-y-8" style="min-width: 260px;">

  <div class="flex flex-col items-center">
    <app-fitmed-logo-white [large]="true"></app-fitmed-logo-white>

    <h1 class="font-bold">Login</h1>
  </div>

  <form class="mt-8 space-y-6" [formGroup]="loginForm" (submit)="login()">
    <input type="hidden" name="remember" value="true">
    <div class="rounded-md shadow-sm flex flex-col space-y-2">
      <!-- Email -->
      <div>
        <label for="username" class="sr-only">{{ 'EmailAddress' | localizeText : 'Email Address' }}</label>
        <input id="username" type="text" placeholder="Email address" formControlName="username"
               class="input-default">
      </div>

      <!-- Password -->
      <div>
        <label for="password" class="sr-only">{{ 'Password' | localizeText : 'Password' }}</label>
        <input id="password" type="password" placeholder="Password" formControlName="password"
               class="input-default">
      </div>

      <app-button
        class="ml-auto"
        type="submit"
        [loading$]="loadingLogin$">
        <div class="px-2 flex space-x-1 items-center">
          <app-icon icon="mdi-login"></app-icon>
          <span>Login</span>
        </div>
      </app-button>
    </div>
  </form>
</div>

<p class="text-white absolute left-0 right-0 text-center bottom-0 mb-3 text-sm">
  <span class="mr-1">{{ 'Visit' | localizeText : 'Visit' }}</span>
  <a href="https://www.fitmed.com" target="_blank" class="font-bold hover:underline">https://www.fitmed.com</a>
  <span class="ml-1 lowercase">{{ 'ForMoreInformationAbout' | localizeText : 'For more information about' }} FitMed</span>
</p>
